module.exports = __webpack_public_path__ + "img/158.79e68640.png";